import { createFileRoute, redirect } from '@tanstack/react-router';
import { StatusVerification } from '@/features/cleaner/verification/status-verification';

export const Route = createFileRoute('/(cleaner)/status-verification')({
  beforeLoad: ({ context }) => {
    // Check if user is authenticated
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/cleaner/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: StatusVerification,
});
